import React from 'react';

const SwitchIcon = ({ width = 16, height = 16, color = '#424242', ...rest }, ref) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...rest}>
      <path
        d="M1 7.5H19L13 1.5M19.3995 12.5H1.3995L7.3995 18.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default React.forwardRef(SwitchIcon);
